import type { FC, ReactNode } from 'react';
import { CreateButton } from '../../components/admin/create-button';
import { cn } from '../../lib/utils';

type MoonstarListActionsProps = {
  left?: ReactNode;
  right?: ReactNode;
  hideCreate?: boolean;
  /** Label of the Create button (default: the kit's "Create") */
  createLabel?: string;
  children?: ReactNode;
  className?: string;
};

export const MoonstarListActions: FC<MoonstarListActionsProps> = ({
  left,
  right,
  children,
  hideCreate,
  createLabel,
  className,
}) => {
  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      {left}
      {!hideCreate && (
        // The kit `CreateButton` is an outline link; restyle it as the primary action
        <span className="inline-flex [&_a]:border-primary [&_a]:bg-primary [&_a]:text-xs [&_a]:text-primary-foreground [&_a:hover]:bg-primary/90 dark:[&_a]:bg-primary dark:[&_a:hover]:bg-primary/90">
          <CreateButton label={createLabel} />
        </span>
      )}
      {right}
      {children}
    </div>
  );
};
